import { createGlobalStyle } from 'styled-components';

export const DisableBodyScroll = createGlobalStyle`
  html, body {
    overflow: hidden;
  }
`;
